import {
  AppAccessLevel,
  GroupUsers,
  UpdateUserEmail,
  User,
  UserActionSuccessTypeEnum,
  UserGroup,
  UserStatus,
} from '@sleipai/sleip-models';
import { createAction, props } from '@ngrx/store';
import { QueryConfig } from '../../helpers';
import { Update } from '@ngrx/entity';

export const loadUsers = createAction('[User] Load Users');

export const loadUsersByIds = createAction(
  '[User] Load Users by Ids',
  props<{ uids: any[] }>()
);

export const loadUsersSuccess = createAction(
  '[User] Load Users Success',
  props<{ users: User[] }>()
);

export const loadSingleUser = createAction(
  '[User] Load single user',
  props<{ uid: string }>()
);

export const loadUsersFromAlgoliaSidbFailure = createAction(
  '[User] Load Users From Algolia Sidb Failure',
  props<{ error: string }>()
);

export const loadUsersForInfiniteScrollList = createAction(
  '[User] Load Users For InfiniteScroll List',
  props<{ reset: boolean; queryConfig: QueryConfig }>()
);

export const loadUsersForInfiniteScrollListSuccess = createAction(
  '[User] Load Users For InfiniteScroll List Success',
  props<{
    users: User[];
    hasMore: boolean;
  }>()
);

export const loadUsersForInfiniteScrollListFailure = createAction(
  '[User] Load Users For InfiniteScroll List Failure',
  props<{ error: string }>()
);

export const loadUsersFailure = createAction(
  '[User] Load Users Failure',
  props<{ error: any }>()
);

export const addUsers = createAction(
  '[User] Add users',
  props<{ users: User[] }>()
);

export const addSingleUser = createAction(
  '[User] Add single user',
  props<{ user: User }>()
);

export const updateUser = createAction(
  '[User] Update user',
  props<{ user: any }>()
);

export const successUpdateUser = createAction('[User] Success Update user');

export const failedUpdateUser = createAction(
  '[User] Failed update user',
  props<{ err: any }>()
);

export const createUser = createAction(
  '[User] Create user',
  props<{ user: any }>()
);

export const createUserSuccess = createAction(
  '[User] Success Create user',
  props<{ userActionSuccessType: UserActionSuccessTypeEnum }>()
);

export const createUserFailure = createAction(
  '[User] Failed Create user',
  props<{ error: any }>()
);

export const updateUserHorsesLoadStatus = createAction(
  '[User] Update user horses load status',
  props<{ horsesLoadStatusUpdatedUser: User }>()
);

export const resetUserSavedSuccess = createAction(
  '[UserGroup] Update User Save Success flag reset'
);

export const loadUserBySearchTerm = createAction(
  '[User] Load User by searchTerm',
  props<{ searchTerm: string; userType?: string }>()
);

export const loadUsersFromAlgoliaSidb = createAction(
  '[User] Load Users from Algolia Sidb',
  props<{
    queryConfig: QueryConfig;
    updateTotalCount: boolean;
  }>()
);

export const loadUsersFromAlgoliaSidbSuccess = createAction(
  '[User] Load Users from Algolia Sidb Success',
  props<{ data: any; updateTotalCount: boolean }>()
);

export const resetUserError = createAction('[User] User Error message reset');

export const actionOnUserSuccess = createAction(
  '[User] Action On User Success',
  props<{
    update?: Update<User>;
    userActionSuccessType: UserActionSuccessTypeEnum;
  }>()
);

export const actionOnUserSuccessReset = createAction(
  '[User] Action On User Success Reset'
);

export const updateUserRemoteShareRightsSetting = createAction(
  '[User] Update User RemoteShareRights Setting',
  props<{ userId: string; remoteShareRights: boolean }>()
);

export const updateUserDesktopWebAppAccessSetting = createAction(
  '[User] Update User UserDesktopWebAppAccess Setting',
  props<{
    userEmail: string;
    userId: string;
    desktopWebAppAccess: boolean;
  }>()
);

export const updateUserIsAdminSetting = createAction(
  '[User] Update User Admin Setting',
  props<{ userId: string; isAdmin: boolean }>()
);

export const updateUserBetaTesterSetting = createAction(
  '[User] Update User Beta tester Setting',
  props<{ userId: string; betaTester: boolean }>()
);

export const updateUserGroupSharingSetting = createAction(
  '[User] Update User UserGroupSharing Setting',
  props<{ groupId: string; groupUser: GroupUsers }>()
);

export const updateUserName = createAction(
  '[User] Update User Name',
  props<{ user: User; name: string }>()
);

export const updateUserCountry = createAction(
  '[User] Update User Country',
  props<{ user: User; country: string }>()
);

export const updateUserUserStatus = createAction(
  '[User] Update User UserStatus',
  props<{ user: User; userStatus: UserStatus }>()
);

export const updateUserTypeAppAccess = createAction(
  '[User] Update User Type AppAccess',
  props<{ user: User; appAccess: AppAccessLevel }>()
);

export const updateUserEmail = createAction(
  '[User] Update User Email',
  props<{ user: User; userEmailUpdateInfo: UpdateUserEmail }>()
);

export const sendResetPasswordEmailForUser = createAction(
  '[User] Send Password Reset Email For User',
  props<{ userEmail: string }>()
);

export const updateGroupInUser = createAction(
  '[User] Update Group In User',
  props<{ user: User; group: UserGroup }>()
);

export const removeUser = createAction(
  '[User] Remove User',
  props<{ userToDelete: User }>()
);

export const removeUserSuccess = createAction(
  '[User] Remove User Success',
  props<{
    userId: string;
    userActionSuccessType: UserActionSuccessTypeEnum;
  }>()
);

export const loadAdminUsers = createAction('[User] Load Admin users');

export const actionUserFailure = createAction(
  '[User] Action User Failure',
  props<{ error: any }>()
);
